import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.pageWidgetRendering.DOC}
  query MosaicPageWidgetsPreview(
    $tenantId: ID!
    $zoneId: ID!
    $widgetIdentifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          widgetPreview(identifier: $widgetIdentifier) {
            ...FragmentMosaicPageWidgetRendering
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicPageWidgetsPreviewQuery,
  models.widget.Preview | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'mosaicDev',
      graphql.transformers.OUT.select(
        'widgetPreview',
        fragments.pageWidgetRendering.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.MosaicPageWidgetsPreviewQuery,
  models.widget.Preview | undefined,
  graphql.schema.MosaicPageWidgetsPreviewQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
